import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {Container} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import AgGridToolbar from "components/AgGridToolbar/AgGridToolbar";
import PageHeader from "components/PageHeader";
import useWindowDimensions from "hooks/Dimensions";
import {SwiftWiresContext} from "./context";
import * as URL from "service/UrlConstant";
import {dateToString, stringToDate} from "utils/FormatUtils";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import {ActionPanelContext} from "context/action";
import {UtilsContext} from "context/utils";
import {useHistory, useLocation} from "react-router-dom";

import {createExcelExportParams, getFilteredColumns, updateColumnHideState} from "../../../utils/ExcelExportUtils";
import {ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE, GRID_COLUMN_PROPERTY} from "../../../utils/Constants";
import {
    addPropertiesToGridColumns,
    getDisplayedNumberOfGridRows,
    getSelectedRows,
} from "../../../utils/gridColumnUtils";
import {getAllErrorValuesAsString} from "../../../utils/ErrorUtils";
import {SWIFT_WIRES_PANEL_ACTIVITIES_PAGE} from "./context/SwiftWiresContext";
import ScrollButton from "../../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
import ActionModifyRenderer from "../../../components/ActionModifyRenderer";

import {normaliseFilterValueAllToEmptyString} from "../../../utils/StringUtils";


export default function SwiftWiresActivitiesPanel() {
    const {
        hiddenExportGridApi,
        paginationPageSize,
        setPaginationPageSize,
        showButton,
        setShowButton
    } = useContext(UtilsContext);
    const {
        swiftWiresDisplayState,
        setSwiftWiresDisplayState,
        showGridToolbar,
        setHeaderCheckedboxChecked,
        selectedRows,
        setSelectedRows,
        selectedAnyCheckbox,
        setSelectedAnyCheckbox,
        setShowGridToolbar,
        buildSwiftWiresActivitiesSearch,
        gridColumnApi,
        setGridColumnApi,
        columnState,setViewClicked,
        setColumnState, getRowStyle
    } = useContext(SwiftWiresContext);
    const {
        makePostRequest,
    } = useContext(SecurityContext);
    const {success, error} = useContext(ToastContext);
    const {
        setHandleExportFunction,
        setHandleCompleteSwiftWiresFunction,
        setHandleRefreshFunction,
    } = useContext(ActionPanelContext);


    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);

    const swiftWiresActivitiesGrid = useRef(null);

    const [columnDefs, setColumnDefs] = useState([]);
    const {isMobile} = useWindowDimensions();
    const myGrid = useRef(null);
    // Guards the one-time initial data load on mount so it does not re-fire on re-renders.
    const hasAutoLoadedRef = useRef(false);
    let history = useHistory();
    let pathname = useLocation().pathname;

    function navigateToPage(path) {
        history.push(path);
    }
    const LogItem = function (params){
        return(<>
            {
                params.value.toString().split("\r\n").map( (log, index) => {
                    return (<React.Fragment key={`log-line-${index}`}>{log}<br /></React.Fragment>)
                })}
        </>);
    }

    const logRenderer = function (props){
        if(!props.data.comments)
            return (<></>)
        return <LogItem value = {props.data.comments}/>
    }
    const logRendererCustodianMessage = function (props){
        if(!props.data.custodianMessage)
            return (<></>)
        return <LogItem value = {props.data.custodianMessage}/>
    }
    const instructionsRenderer = function (props){
        if(!props.data.wireInstructions)
            return (<></>)
        return <LogItem value ={props.data.wireInstructions}/>
    }

    const exportQueryList = (type, rowData) => {
        //Set Column definition
        const swiftWiresActsColumnsDef = columnDefsActivitiesPanel.filter(cols => cols.field !== 'checkbox' && cols.field !== 'View')
        hiddenExportGridApi.current.api.setColumnDefs(swiftWiresActsColumnsDef);
        //Set Data
        hiddenExportGridApi.current.api.setRowData(rowData || swiftWiresDisplayState.swiftWiresActivitiesSearch.resData);
        let filteredColumnNames = getFilteredColumns(swiftWiresActivitiesGrid);
        //Export as csv/excel
        type === 'EXCEL' ?
            hiddenExportGridApi.current.api.exportDataAsExcel(createExcelExportParams('SwiftWires', filteredColumnNames)) :
            hiddenExportGridApi.current.api.exportDataAsCsv({columnKeys: filteredColumnNames});
    }

    const setupActionColumns = () => {
        let updatedColumnDefs = [...columnDefsActivitiesPanel];
        updatedColumnDefs = addPropertiesToGridColumns(updatedColumnDefs, GRID_COLUMN_PROPERTY)
        setColumnDefs(updatedColumnDefs);
    }
    const handleSwiftWiresComplete = () => {
        const selected = getSelectedRows(gridApi);
        setSelectedRows(selected);
    }




    const loadSwiftWiresSearch = () => {
        const searchCriteria = {
            refType: swiftWiresDisplayState.swiftWiresActivitiesSearch.refType,
            indStatus: swiftWiresDisplayState.swiftWiresActivitiesSearch.status,
            transId: swiftWiresDisplayState.swiftWiresActivitiesSearch.transId,
            swiftRefNum: swiftWiresDisplayState.swiftWiresActivitiesSearch.reference,
            mnyOut: swiftWiresDisplayState.swiftWiresActivitiesSearch.direction === 'IN' ? 0 : null,
            mnyIn: swiftWiresDisplayState.swiftWiresActivitiesSearch.direction === 'OUT' ? 0 : null,
            dtEffective: dateToString(swiftWiresDisplayState.swiftWiresActivitiesSearch.dtEffective)
        }


        const onSuccessResponse = (response) => {
            let swiftWiresDisplayStateShowActivities = {...swiftWiresDisplayState};

            if (!response.data || response.data.length === 0) {
                swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.resData = [];
            } else {
                swiftWiresDisplayStateShowActivities.swiftWiresActivitiesSearch.resData = response.data;
            }
            setShowGridToolbar(response.data && response.data.length > 0)
            swiftWiresDisplayStateShowActivities.currentPage = SWIFT_WIRES_PANEL_ACTIVITIES_PAGE;
            setSwiftWiresDisplayState(swiftWiresDisplayStateShowActivities);
            setColumnState(null);
        }

        const onErrorResponse = (err) => {
            let errorMsg = getAllErrorValuesAsString(err.response.data)
            console.error("Error occurred with reloading SwiftWires",errorMsg);
            error("Error occurred with reloading SwiftWires");
        }

        makePostRequest(searchCriteria,
            URL.SWIFT_WIRES_URL_SEARCH, onSuccessResponse, onErrorResponse);
    }

    const completeSwiftWiresSearch = (userSelectedRows, onSuccess, onError, swiftWireReference) => {

        const params = {
            idWireNum: userSelectedRows?.[0]?.idWireNum,
            idVersion: userSelectedRows?.[0]?.version,
            fedIntlWireRefNum: swiftWireReference,
            cdClient: userSelectedRows?.[0]?.cdClient,
        }

        const onSuccessResponse = () => {
            if (onSuccess) onSuccess();
            success("Swift Wire was completed successfully");

            setSelectedAnyCheckbox(false)
            setSelectedRows([]);

            loadSwiftWiresSearch();
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if (onError) onError(err);

            const responseData = err.response?.data;
            let errMsg = "An error occurred while completing the Swift Wire";
            if (typeof responseData === 'string') {
                errMsg = responseData;
            } else if (responseData && typeof responseData === 'object') {
                errMsg = Object.values(responseData).join(', ');
            }
            error(errMsg);
        }

        makePostRequest(params, URL.SWIFT_WIRES_URL_COMPLETE, onSuccessResponse, onErrorResponse);

    }
    useEffect(() => {
        setupActionColumns();
        const rowData = swiftWiresDisplayState.swiftWiresActivitiesSearch.resData
        setRowData(rowData);
        setHandleRefreshFunction({handleRefresh: handleRefreshActionClicked, gridApi:null });
        setHandleExportFunction({handleExport: exportQueryList, gridApi: gridApi});
        setHandleCompleteSwiftWiresFunction({handleSwiftWiresComplete: completeSwiftWiresSearch, gridApi: gridApi})
    }, [swiftWiresDisplayState, columnState])

    // Load data once on initial mount using the default filter values defined in the context
    // (e.g. Status = ACK). Subsequent loads are driven by the user's Search action or refresh,
    // so this guarded one-time fetch does not interfere with those flows.
    useEffect(() => {
        if (hasAutoLoadedRef.current) {
            return;
        }
        hasAutoLoadedRef.current = true;
        loadSwiftWiresSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const defaultColDef = {
        sortable: true,
        resizable: true,
        floatingFilter: true,
        filter: true,
        enableCellChangeFlash: true,
        lockPinned: !!isMobile,
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    function pageTitle() {
        return (<>
            Swift Wires Activities
        </>)
    }

    const onDataRendered = (params) => {
        params.columnApi.autoSizeAllColumns();
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }


    const isRowSelectable = useCallback((params) => {
        return (!!params.data) && ['ACK'].includes(params.data.indStatus);
    }, []);

    const onSelectionChanged = useCallback((params) => {
        const userSelectedRows = params.api.getSelectedRows();
        setHeaderCheckedboxChecked(userSelectedRows.length > 0)
        setSelectedAnyCheckbox(userSelectedRows.length > 0)
    }, [])

    useEffect(() => {
        if (gridApi) {
            gridApi.deselectAll();
        }
        setHeaderCheckedboxChecked(false);
        setSelectedAnyCheckbox(false);
    }, [pathname.key])

    useEffect(() => {
        if (columnState?.columnState &&
            Array.isArray(columnState?.columnState) &&
            columnState?.columnState?.length > 0) {
            const updatedColumnDefs = updateColumnHideState(columnDefsActivitiesPanel, columnState);
            setColumnDefs(updatedColumnDefs)
        }
    }, [columnState]);

    const onPaginationChange = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const handleRefreshActionClicked = (refreshCriteria ,gridApi , onSuccess, onError) => {
        //handleRefresh(refreshCriteria)
        loadSwiftWiresSearch();
    };

    return (<>
        <Container fluid>
            <PageHeader text={pageTitle()}>
            </PageHeader>

            { showGridToolbar && <AgGridToolbar
                swiftWiresScreen={true}
                gridApi={gridApi}
                gridColumnApi={gridColumnApi}
                columnDefs={columnDefs}
                setColumnDefs={setColumnDefs}
                refreshCriteria={swiftWiresDisplayState.swiftWiresActivitiesSearch}
                handleSwiftWiresComplete={handleSwiftWiresComplete}
                rowData={rowData}
                paginationPageSize={paginationPageSize}
                setPaginationPageSize={setPaginationPageSize}
                selectedAnyCheckbox={selectedAnyCheckbox}
                selectedRows={selectedRows}
            >
            </AgGridToolbar>}
            <div
                ref={myGrid}
                id="myGrid"
                className="ag-theme-alpine ag-grid-block">
                <AgGridReact
                    pagination={true}
                    ref={swiftWiresActivitiesGrid}
                    onPaginationChanged={onPaginationChange}
                    paginationPageSize={paginationPageSize}
                    frameworkComponents={{
                        modifyRenderer: ActionModifyRenderer,
                        logRenderer: logRenderer,
                        logRendererCustodianMessage: logRendererCustodianMessage,
                        instructionsRenderer: instructionsRenderer
                    }}
                    groupDefaultExpanded={'1'}
                    enableRowGroup={false}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    suppressModelUpdateAfterUpdateTransaction={true}
                    suppressScrollOnNewData={true}
                    suppressAggFuncInHeader={true}
                    allowShowChangeAfterFilter={false}
                    rowGroupPanelShow={'never'}
                    enableSorting={true}
                    enableFilter={true}
                    onGridReady={onGridReady}
                    onRowDataChanged={onDataRendered}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}
                    rowData={rowData}
                    animateRows={true}
                    isRowSelectable={isRowSelectable}
                    onSelectionChanged={onSelectionChanged}
                    rowSelection={"single"}
                    getRowStyle={getRowStyle}
                >
                </AgGridReact>
            </div>
        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}

    </>);
}

const columnDefsActivitiesPanel = [
    {
        headerName: '',
        headerCheckboxSelection: false,
        field: "checkbox",
        minWidth: 120,
        cellClass: 'checkbox-top-align',
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        cellClassRules: {
            "checkbox-disabled": (params) => {
                return !params.data || !['ACK'].includes(params.data.indStatus) ;
            },
        }
    },
    {headerName: 'id', field: 'id',hide:true, colId: 'id', suppressColumnsToolPanel:true},
    {headerName: 'idWire', field: 'idWireNum',hide:true, colId: 'idWireNum', suppressColumnsToolPanel:true},
    {headerName: 'version', field: 'version',hide:true, colId: 'idVersion', suppressColumnsToolPanel:true},
    {headerName: 'Status', field: 'indStatus'},
    {headerName: 'Effective', field: 'dtEffective', valueGetter: (params)=>stringToDate(dateToString(params.data.dtEffective))},
    {headerName: 'Client', field: 'cdClient'},
    {headerName: '3rd Party', field: 'thirdParty'},
    {headerName: 'Funds Out', field: 'mnyOut'},
    {headerName: 'CcyOut', field: 'ccyOut'},
    {headerName: 'Reason', field: 'reason'},
    {headerName: 'Funds In', field: 'mnyIn'},
    {headerName: 'CcyIn', field: 'ccyIn'},
    {headerName: 'WireInst', field: 'wireInstructions', wrapText: true, autoHeight: true, resizable: true, minWidth: 350, cellRenderer: 'instructionsRenderer'},
    {headerName: 'Comments', field: 'comments', type: 'FlexHeightColType',cellRenderer: 'logRenderer'},
    {headerName: 'WireRefNum', field: 'fedIntlWireRefNum'},
    {headerName: 'SenderBic',field:'senderBic'},
    {headerName: 'RspSent',field:'rspSent'},
    {headerName: 'UniqRspId',field:'uniqRspId'},
    {headerName: 'indDirection',field:'indDirection'},
    {headerName: 'Custodian Message', field: 'custodianMessage',wrapText :true,autoHeight:true,resizable:true, cellRenderer: 'logRendererCustodianMessage'},
    //{headerName: 'IndDirection',field:'indDirection', filter: 'agSetColumnFilter', filterParams: { suppressMiniFilter: false }},
    {headerName: '', field: '', type: 'flexColType', suppressColumnsToolPanel: true},
];
